import { dataHooks } from '../../../libs/dataHooks';

export const hirePartnerBannerDataHooks = dataHooks<{
  mainCTA: {};
  closeButton: {};
  banner: {};
}>('hirePartnerBanner');
